"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.default = exports.Icon = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var icons = _interopRequireWildcard(require("./../icons"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Icon component
 * @method
 * @param {object} props - React properties passed from composition
 * @returns Icon
 */
/**
 * To contribute to the Palette icons repo, add your SVG file to the src/icons folder. Then when you run `npm start`, Palette will rebuild the icons and convert it to a react component. You can then add it to the correct category in iconList.js (.storybook/components/IconGrid/iconList.js). All icons are UI icons by default.
 */
const Icon = props => {
  const {
    burst,
    className,
    name,
    focusable = defaultProps.focusable,
    id,
    role = defaultProps.role,
    description,
    title,
    inverted = defaultProps.inverted,
    size = defaultProps.size,
    ariaHidden = defaultProps.ariaHidden,
    disabled = defaultProps.disabled,
    ...other
  } = props;
  const pascalToLowerCase = str => {
    return str.toLowerCase();
  };
  const getIconSize = () => {
    switch (size) {
      case 'lg':
        return {
          width: 16,
          height: 16
        };
      case 'xl':
        return {
          width: 24,
          height: 24
        };
      case 'xxl':
        return {
          width: 40,
          height: 40
        };
      case 'cc':
        return {
          width: 40,
          height: 24
        };
      case 'custom':
        {
          return {
            width: '100%',
            height: '100%'
          };
        }
      default:
        return {
          width: 12,
          height: 12
        };
    }
  };
  const lowerCaseIconName = pascalToLowerCase(name);
  const SvgIcon = icons[lowerCaseIconName];
  const BurstIcon = icons['burst'];
  const {
    width,
    height
  } = getIconSize();
  const isCircularLoader = name === 'loader';
  const componentClassName = (0, _classnames.default)('pal-c-Icon', {
    'pal-c-Icon--inverted': inverted === true,
    'pal-c-Icon--circularLoader': isCircularLoader === true,
    [`pal-c-Icon--size-${size}`]: size,
    'pal-c-Icon--disabled': disabled,
    [`${className}`]: className
  });
  const burstClassName = (0, _classnames.default)('pal-c-Icon--burstWrapper', {
    'pal-c-Icon--inverted': inverted === true,
    [`pal-c-Icon--size-${size}`]: size
  });
  if (!SvgIcon) {
    return null;
  }
  const svgContent = burst ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SvgIcon, _extends({
    id: id,
    className: componentClassName,
    "aria-hidden": ariaHidden,
    focusable: focusable,
    role: role,
    height: height,
    width: width,
    title: title,
    description: description
  }, other)), /*#__PURE__*/_react.default.createElement(BurstIcon, {
    "aria-hidden": true,
    className: "pal-c-Icon--burst",
    focusable: "false",
    role: role
  })) : /*#__PURE__*/_react.default.createElement(SvgIcon, _extends({
    id: id,
    className: componentClassName,
    "aria-hidden": ariaHidden,
    focusable: focusable,
    role: role,
    height: height,
    width: width,
    title: title,
    description: description
  }, other));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, burst && /*#__PURE__*/_react.default.createElement("div", {
    className: burstClassName
  }, svgContent), !burst && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, svgContent));
};

/**
 * Property type definitions
 * @type {object}
 * @property {boolean} focusable - Declares whether the icon is focusable or not for accessibility
 * @property {string} name - Name of icon to reference in icon sprite
 * @property {string} className - className for the icon
 * @property {string} id - icon id
 * @property {boolean} inverted - Inverted variant for dark backgrounds
 * @property {string} title - SVG title which serves as alt text for the SVG.
 * @property {string} size - The size of the icon
 * @property {string} role - Role for the svg (ADA)
 * @property {boolean} ariaHidden - aria-hidden property for svg (ADA)
 * @property {string} description - description property for svg (ADA)
 * @property {boolean} disabled - adds grayscale filter to icons
 */
exports.Icon = Icon;
Icon.propTypes = {
  /**
   * Name of icon to reference in icon sprite
   */
  name: _propTypes.default.string,
  /**
   * The size of the icon
   * - default - 12X12  size of the UI icons
   * - lg - 16X16 size of the UI icons
   * - xl - 24X24 size used for social and conscious icons
   * - xxl - 40X40 largest icon size for UI icons
   * - cc - 40X24 size to be used for credit cards and payment icons
   * - custom - 100% X 100% size for icons with custom height and width provided through svg
   */
  size: _propTypes.default.oneOf(['default', 'lg', 'xl', 'xxl', 'cc', 'custom']),
  /**
   * Declares whether the icon is focusable or not for accessibility
   */
  focusable: _propTypes.default.bool,
  /**
   * ID used so the svg can read the title of the SVG icon to the user when accessibility is needed
   */
  id: _propTypes.default.string,
  /**
   * Inverted variant for dark backgrounds
   */
  inverted: _propTypes.default.bool,
  /**
   * SVG title which serves as alt text for the SVG.
   */
  title: _propTypes.default.string,
  /**
   * SVG description for ADA
   */
  description: _propTypes.default.string,
  /**
   * Role for the svg (ADA)
   */
  role: _propTypes.default.string,
  /**
   * aria-hidden to be set for svg (ADA)
   */
  ariaHidden: _propTypes.default.bool,
  /**
   * sets grayscale filter to icon
   */
  disabled: _propTypes.default.bool
};

/**
 * Property type definitions
 * @type {object}
 * @property {boolean} focusable - set the default focusable property for icon
 * @property {string} size - set the default value for size
 * @property {string} role - set the default role for svg
 * @property {boolean} disabled - set the default disabled boolean value for icon
 */
const defaultProps = exports.defaultProps = {
  focusable: false,
  inverted: false,
  ariaHidden: true,
  size: 'default',
  role: 'img',
  disabled: false
};
var _default = exports.default = Icon;